import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login, formatApiErrorDetail } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(form.email.trim(), form.password);
      toast.success("Welcome back");
      const to = loc.state?.from || "/";
      nav(to);
    } catch (e2) {
      const msg = formatApiErrorDetail(e2.response?.data?.detail) || e2.message;
      setErr(msg);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="login-page" className="min-h-[70vh] flex items-center py-12">
      <div className="container-page grid md:grid-cols-2 gap-10 items-center">
        <div className="hidden md:block">
          <div className="text-xs font-bold uppercase tracking-widest text-accent mb-3">Welcome back</div>
          <h1 className="font-montserrat font-extrabold text-4xl lg:text-5xl text-slate-900 leading-tight">
            Your next trip starts with a tap.
          </h1>
          <p className="mt-3 text-slate-600 max-w-md">
            Log in to save deals, track price drops and unlock member-only fares from our partners.
          </p>
          <img src="https://images.pexels.com/photos/8281079/pexels-photo-8281079.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="mt-8 w-full h-64 object-cover rounded-2xl border border-slate-200" />
        </div>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 max-w-md w-full mx-auto" data-testid="login-form">
          <h2 className="font-montserrat font-bold text-2xl text-slate-900">Log in</h2>
          <p className="text-sm text-slate-500 mt-1">Welcome back to MyTripPoint.</p>
          {err && <div className="mt-4 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="login-error">{err}</div>}
          <div className="mt-5 space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-widest text-slate-500">Email</label>
              <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" className="mt-1 w-full h-11 px-3 rounded-lg border border-slate-200 focus:outline-none focus:border-brand text-sm" />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-widest text-slate-500">Password</label>
              <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" className="mt-1 w-full h-11 px-3 rounded-lg border border-slate-200 focus:outline-none focus:border-brand text-sm" />
            </div>
          </div>
          <button disabled={busy} data-testid="login-submit" className="mt-6 w-full h-12 rounded-lg btn-brand text-white font-semibold disabled:opacity-60">
            {busy ? "Signing in..." : "Sign in"}
          </button>
          <div className="text-sm text-slate-600 mt-4 text-center">
            New to MyTripPoint? <Link to="/register" className="text-brand font-semibold">Create account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
